import { Info } from "lucide-react";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

interface BlockFieldProps {
  name: string | null;
  children: React.ReactNode;
  className?: string;
  helpTooltip?: string;
}

const BlockField = ({ children, name, className, helpTooltip }: BlockFieldProps) => (
  <div className={cn("space-y-2", className)}>
    {name && (
      <div className="flex items-center gap-2">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{name}</label>
        {helpTooltip && (
          <BasicTooltip content={helpTooltip}>
            <Info className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
          </BasicTooltip>
        )}
      </div>
    )}
    <div className="w-full">{children}</div>
  </div>
);

export default BlockField;
